module.exports = __webpack_public_path__ + "img/4.f5c42d31.svg";